import Vue from 'vue'
// import WeVue from 'we-vue'
// import 'we-vue/lib/style.css'
import App from './App'
import VueTouch from 'vue-touch'
import router from './router'
import 'lib-flexible/flexible.js'
import './assets/font-icon/iconfont.css'
// import 'weui/dist/style/weui.min.css'
// import {post} from './utils/rest'
import Calendar from 'vue-mobile-calendar'
import './assets/common.css'
import Vant from 'vant'
import 'vant/lib/index.css'
// const TARGET = require('../src/utils/target')
Vue.use(VueTouch, { name: 'v-touch' })
Vue.config.productionTip = false
// Vue.use(WeVue)
Vue.use(Calendar)
Vue.use(Vant)
Vue.config.ignoredElements = [
  'wx-open-launch-weapp' // 忽略微信开放标签
]
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js